import PropTypes from 'prop-types';

export default PropTypes.shape({
  addLayer: PropTypes.func.isRequired,
  removeLayer: PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/es/propTypes/layerContainer.js
// module id = 141
// module chunks = 0